/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import * as account from "./account";
import * as image from "../../common/image";
import * as currency from "../../common/currency";
export { account, image, currency };
export var ViolationType = {
  Withdraw: 1
};
export var FilterOptionScene = {
  PlanFilterOption: 1,
  SampleFilterOption: 2,
  AgencySampleFilterOption: 3
};
export var FilterPanelEnum = {
  Creator: 1,
  Follower: 2,
  Performance: 3,
  Sample: 4
};
export var SearchKey = {
  INVALID: 0,
  CREATOR_NAME: 1,
  CREATOR_ID: 2,
  PRODUCT_NAME: 3,
  PRODUCT_ID: 4,
  CREATOR_FOLLOWERS: 5,
  PACKAGE_ID: 6,
  COLLECTION_METHOD: 7,
  CREATOR_LABEL: 8,
  MAIN_ORDER_ID: 9,
  CREATOR_AGENCY: 10,
  CREATOR_MAIN_CATEGORY: 11,
  CREATOR_FOLLOWER_GENDER: 12,
  CREATOR_FOLLOWER_AGE: 13,
  CREATOR_CONTENT_TYPE: 14,
  CREATOR_COOPERATED_WITH_BEFORE: 15,
  CREATOR_REJECTED_BEFORE: 16,
  CREATOR_GMV_RANGE: 17,
  CREATOR_GPM_RANGE: 18,
  CREATOR_AVG_VIDEO_VIEWS: 19,
  CREATOR_AVG_LIVE_VIEWS: 20,
  CREATOR_RELIABLE_WITH_SAMPLES: 21,
  SOON_TO_EXPIRE: 22,
  SAMPLE_FULFILLMENT_RATE: 25,
  FULFILLMENT_RANK: 51
};
export var SearchType = {
  KEYWORD: 1,
  WILDCARD: 2,
  RANGE: 3,
  IN: 4,
  BOOL: 5
};
export var FollowerGender = {
  GENDER_ALL: 0,
  MALE: 1,
  FEMALE: 2
};
export var CreatorAgencyType = {
  CREATOR_AGENCY_All: 0,
  MANAGED_BY_AGENCY: 1,
  INDEPENDENT_CREATOR: 2
};
export var FilterOptionType = {
  CheckBox: 1,
  Radio: 2,
  Switch: 3,
  Input: 4,
  Select: 5
};
export var OptionValueType = {
  Enumeration: 1,
  Range: 2
};
export var AffiliateOCOptInCardType = {
  AFFILIATE_OC_OPTIN_CARD_TYPE_SIGN_UP: 1,
  AFFILIATE_OC_OPTIN_CARD_TYPE_COMMON: 2
};
export var TodoListItemAction = {
  CTA: 1,
  Report: 2
};
export var AffiliateCenterFeature = {
  BlockCreator: 1,
  CreatorApproveToggle: 2
};
export var MerchantSwitchType = {
  LinkShare: 1
};
export var MerchantSwitchStatus = {
  Close: 1,
  Open: 2
};